import 'slick-carousel'

        $(document).ready(function () {
    var $status = $('.slider_nr');
    var $slickSliedr = $('.slick-slider');

    var $slickElement = $('.slick-akt');


    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        setTitleDesc();
    });


    function setTitleDesc() {
        var akt_data = $('.slick-active .akt_data').text();
        var akt_name = $('.slick-active .akt_name').text();
        var akt_short_content = $('.slick-active .akt_short_content').text();
        var a_href = $('.slick-active .akt_slug').text();


        if (akt_data) {
            $('.slider_text .move_akt_data').css('visibility', 'visible');
            $('.slider_text .move_akt_data').text(akt_data);
        } else {
            $('.slider_text .move_akt_data').css('visibility', 'hidden');
        }

        if (akt_name) {
            $('.slider_text .move_akt_name').css('visibility', 'visible');
            $('.slider_text .move_akt_name').text(akt_name);
        } else {
            $('.slider_text .move_akt_name').css('visibility', 'hidden');
        }
        if (akt_short_content) {
            $('.slider_text .move_akt_short_content').css('visibility', 'visible');
            $('.slider_text .move_akt_short_content').text(akt_short_content);
        } else {
            $('.slider_text .move_akt_short_content').css('visibility', 'hidden');
        }

        if (a_href) {
            $('.slider_text .akt_btn').css('visibility', 'visible');
            $('.slider_text .akt_btn .btn_multi').attr('href', a_href);

        } else {
            $('.slider_text .akt_btn').css('visibility', 'hidden');
        }
    }

// $slickElement.slick({
//     slide: 'img',
//     autoplay: true,
//     dots: true
// });

    $slickElement.slick({
        infinite: true,
        autoplay: true,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 300,
        autoplaySpeed: 4000,
        dots: true,
        fade: true,
        lazyLoad: 'ondemand'
    });


    $slickSliedr.slick({
        infinite: true,
        autoplay: true,
        arrows: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 300,
        autoplaySpeed: 4000,
        dots: false,
        arrows: true,
        fade: true,
        lazyLoad: 'ondemand',
        prevArrow: '<div class="arrow left-home"><div class="abs_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.001" height="26.008" viewBox="0 0 14.001 26.008"><path data-name="Union 58" d="m15994 21979 10 11zm10-11-10 11z" transform="translate(-15991.996 -21965.996)" style="fill:none;stroke:#006533;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div></div>',
        nextArrow: '<div class="arrow right-home"><div class="abs_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="26.004" viewBox="0 0 14 26.004"><path data-name="Union 58" d="M0 11 10 0zm10 11L0 11z" transform="rotate(180 6 12.002)" style="fill:none;stroke:#006533;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div></div>',        
        //nextArrow: '<div class="arrow right-home"><div class="abs_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="8.987" height="14"><path data-name="Path 5" d="M13.837 2.387a.561.561 0 0 0 0-.791L12.395.163a.551.551 0 0 0-.782 0L7 4.776 2.387.163a.551.551 0 0 0-.782 0L.163 1.6a.561.561 0 0 0 0 .791l6.446 6.433a.551.551 0 0 0 .782 0z" transform="rotate(-90 7 7)" style="fill:#fff"/></svg></div></div>',
        //prevArrow: '<div class="arrow left-home"><div class="abs_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="8.987" height="14"><path data-name="Path 5" d="M13.837 2.387a.561.561 0 0 0 0-.791L12.395.163a.551.551 0 0 0-.782 0L7 4.776 2.387.163a.551.551 0 0 0-.782 0L.163 1.6a.561.561 0 0 0 0 .791l6.446 6.433a.551.551 0 0 0 .782 0z" transform="rotate(90 4.494 4.494)" style="fill:#fff"/></svg></div></div>',
    });


    var $slickTable = $('.table__gallery-slider');
    $slickTable.slick({
        infinite: true,
        autoplay: true,
        arrows: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        speed: 300,
        autoplaySpeed: 4000,
        dots: false,
        lazyLoad: 'ondemand',
        prevArrow: '<div class="arrow left-home"><div class="abs_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.001" height="26.008" viewBox="0 0 14.001 26.008"><path data-name="Union 58" d="m15994 21979 10 11zm10-11-10 11z" transform="translate(-15991.996 -21965.996)" style="fill:none;stroke:#006533;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div></div>',
        nextArrow: '<div class="arrow right-home"><div class="abs_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="26.004" viewBox="0 0 14 26.004"><path data-name="Union 58" d="M0 11 10 0zm10 11L0 11z" transform="rotate(180 6 12.002)" style="fill:none;stroke:#006533;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div></div>',        
        //nextArrow: '<div class="arrow_table arrow_right_table"><div class="abs_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 32 27.429"><path id="prefix__left-arrow_2_" d="M18.277 34.446L32 48.16 18.281 61.875l-1.616-1.611L27.625 49.3H0v-2.283h27.625L16.661 36.053z" data-name="left-arrow (2)" transform="translate(0 -34.446)" style="fill:#fff"/></svg></div></div>',
        //prevArrow: '<div class="arrow_table arrow_left_table"><div class="abs_arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 32 27.429"><path id="prefix__left-arrow_2_" d="M18.277 34.446L32 48.16 18.281 61.875l-1.616-1.611L27.625 49.3H0v-2.283h27.625L16.661 36.053z" data-name="left-arrow (2)" transform="translate(0 -34.446)" style="fill:#fff"/></svg></div></div>',
    });


    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        // centerMode: true,
        arrows: false,
        focusOnSelect: true,
        // responsive: [
        //   {
        //     breakpoint: 1139,
        //     settings: {
        //       slidesToShow: 5,
        //     slidesToScroll: 1,
        //     }
        //   },
        //   {
        //     breakpoint: 767,
        //     settings: {
        //       slidesToShow: 4,
        //       slidesToScroll: 1,
        //     }
        //   },
        //   {
        //     breakpoint: 600,
        //     settings: {
        //       slidesToShow: 3,
        //       slidesToScroll: 1,
        //     }
        //   },
        //   {
        //     breakpoint: 480,
        //     settings: {
        //       slidesToShow: 2,
        //       slidesToScroll: 1,
        //     }
        //   },
        //   {
        //     breakpoint: 380,
        //     settings: {
        //       slidesToShow: 2,
        //       slidesToScroll: 1,
        //     }
        //   }
        // ]
    });

    $('.home-news-list-slick').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        // variableWidth: true,
        autoplaySpeed: 2000,
        prevArrow: '<div class="arrowPartnerzy arrowPartnerzy-prev"><svg xmlns="http://www.w3.org/2000/svg" width="14.001" height="26.008" viewBox="0 0 14.001 26.008"><path data-name="Union 58" d="m15994 21979 10 11zm10-11-10 11z" transform="translate(-15991.996 -21965.996)" style="fill:none;stroke:#006533;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div>',
        nextArrow: '<div class="arrowPartnerzy arrowPartnerzy-next"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="26.004" viewBox="0 0 14 26.004"><path data-name="Union 58" d="M0 11 10 0zm10 11L0 11z" transform="rotate(180 6 12.002)" style="fill:none;stroke:#006533;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div>',
        //nextArrow: '<div class="arrowPartnerzy arrowPartnerzy-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="56.004" viewBox="0 0 24 56.004"><path data-name="Union 2" d="M0 26 20 0zm20 26L0 26z" transform="rotate(180 11 27.002)" style="fill:none;stroke:#032a16;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div>',
        //prevArrow: '<div class="arrowPartnerzy arrowPartnerzy-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25.001" height="56" viewBox="0 0 25.001 56"><path data-name="Union 1" d="m15994 21994 21 26zm21-26-21 26z" transform="translate(-15991.998 -21966)" style="fill:none;stroke:#032a16;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div>',
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
//                    arrows: false,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
//                    arrows: false,
                }
            }
        ]
    });



    $('.partnerzy-logowki').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        // variableWidth: true,
        autoplaySpeed: 2000,
        nextArrow: '<div class="arrowPartnerzy arrowPartnerzy-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="56.004" viewBox="0 0 24 56.004"><path data-name="Union 2" d="M0 26 20 0zm20 26L0 26z" transform="rotate(180 11 27.002)" style="fill:none;stroke:#032a16;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div>',
        prevArrow: '<div class="arrowPartnerzy arrowPartnerzy-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25.001" height="56" viewBox="0 0 25.001 56"><path data-name="Union 1" d="m15994 21994 21 26zm21-26-21 26z" transform="translate(-15991.998 -21966)" style="fill:none;stroke:#032a16;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px"/></svg></div>',
        responsive: [
            {
                breakpoint: 1349,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    variableWidth: true,
                    centerMode: true,
                }
            },
            {
                breakpoint: 485,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true,
                    centerMode: true,
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });



    $('.powiazane_slick').slick({
        dots: true,
        infinite: true,
        speed: 300,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        nextArrow: '<div class="powiazane_arrow_right"><svg width="32" height="32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.008 512.008" style="enable-background:new 0 0 512.008 512.008;" xml:space="preserve"><g><g><path d="M381.048,248.633L146.381,3.299c-3.021-3.146-7.646-4.167-11.688-2.521c-4.042,1.615-6.688,5.542-6.688,9.896v42.667 c0,2.729,1.042,5.354,2.917,7.333l185.063,195.333L130.923,451.341c-1.875,1.979-2.917,4.604-2.917,7.333v42.667 c0,4.354,2.646,8.281,6.688,9.896c1.292,0.521,2.646,0.771,3.979,0.771c2.854,0,5.646-1.146,7.708-3.292l234.667-245.333 C384.986,259.258,384.986,252.758,381.048,248.633z"/></g></g></svg></div>',
        prevArrow: '<div class="powiazane_arrow_left"><svg width="32" height="32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.008 512.008" style="enable-background:new 0 0 512.008 512.008;" xml:space="preserve"><g><g><path d="M381.048,248.633L146.381,3.299c-3.021-3.146-7.646-4.167-11.688-2.521c-4.042,1.615-6.688,5.542-6.688,9.896v42.667 c0,2.729,1.042,5.354,2.917,7.333l185.063,195.333L130.923,451.341c-1.875,1.979-2.917,4.604-2.917,7.333v42.667 c0,4.354,2.646,8.281,6.688,9.896c1.292,0.521,2.646,0.771,3.979,0.771c2.854,0,5.646-1.146,7.708-3.292l234.667-245.333 C384.986,259.258,384.986,252.758,381.048,248.633z"/></g></g></svg></div>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });



    $('.product_slick').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: '<div class="arrow_prod arrow_next"><svg xmlns="http://www.w3.org/2000/svg" width="8.998" height="18.996"><path data-name="Union 5" d="m4240 19751 8 9zm8-9-8 9z" transform="translate(-4239.5 -19741.504)" style="fill:none;stroke:#fff;stroke-linejoin:round"/></svg></div>',
        prevArrow: '<div class="arrow_prod arrow_left"><svg xmlns="http://www.w3.org/2000/svg" width="8.998" height="18.996"><path data-name="Union 5" d="m4240 19751 8 9zm8-9-8 9z" transform="translate(-4239.5 -19741.504)" style="fill:none;stroke:#fff;stroke-linejoin:round"/></svg></div>',

        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1139,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 585,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});